import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:45</span>Introduction of our guest</li>
                            <li><span>01:21</span>How JR Ridge got into entrepreneurship</li>
                            <li><span>02:47</span>The fear of failure in taking the first step into building your business?</li>
                            <li><span>06:13</span>Finding the right partner for your business</li>
                            <li><span>07:12</span>How do deal with the voice in the back of your mind that tells you to quit when things aren’t going well?</li>
                            <li><span>09:55</span>Why aspiring entrepreneurs delay executing an idea</li>
                            <li><span>13:11</span>Motivation for entrepreneurs through a personal story.</li>
                            <li><span>17:10</span>What is Guardian Angel? A story of saving lives.</li>
                            <li><span>18:40</span>The impact of Guardian Angel on society.</li>
                            <li><span>23:15</span>The future of Guardian Angel</li>
                            <li><span>25:52</span>How has the COVID-19 pandemic affected different aspects of the business?</li>
                            <li><span>31:16</span>Why choose Mobile app development as the medium?</li>
                            <li><span>33:45</span>How do you monetize an app?</li>
                            <li><span>35:35</span>The future of tech : Machine learning and Artificial Intelligence</li>
                            <li><span>43:13</span>Role of entrepreneurs in giving back to the society.</li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;